<template>
  <div class="ticket">
    <div class="ticket_content">
      <div class="ticket_content_head">
        <i class="el-icon-arrow-left" @click="backFn"></i>
        <h6>订单列表</h6>
      </div>
      <div class="ticket_content_item">
        <div class="ticket_content_list" v-for="(i, index) in list" @click="showList(i)">
          <div>
            <div class="ticket_content_list_tab" v-if="i.autoBrandCode || i.tableName">
              <span v-if="i.autoBrandCode">取餐号：{{i.autoBrandCode}}</span>
              <span v-else-if="i.tableName">桌台号：{{i.tableName}}</span>
            </div>
            <h6 v-if="i.orderCode">订单号：{{i.orderCode}}</h6>
            <h5 v-if="i.orderCode">{{i.createTime}}</h5>
            <h5 style="padding-top: 10px;" v-else>{{i.createTime}}</h5>
            <div style="display: flex;">
              <h4>{{i.shopName}}</h4>
            </div>
          </div>
          <p>￥{{i.realityMoney}}</p>
        </div>
      </div>
    </div>

    <!-- 显示订单详情 -->
    <div class="ticket_window" v-show="showInfo">
      <div class="ticket_window_head">
        <i class="el-icon-arrow-left" @click="showInfo=false"></i>
        <h6>订单详情</h6>
      </div>
      <div class="ticket_wrap">
        <h2 class="ticket_shopName">{{info.shopName}}</h2>
        <!-- <h3 class="ticket_title">{{info.tableName}}</h3> -->
        <div class="ticket_head">
          <h2 v-if="info.autoBrandCode">取餐号：{{info.autoBrandCode}}</h2>
          <!-- <h2 v-if="info.autoBrandCode && model == 3">取餐号：{{info.autoBrandCode}}</h2> -->
          <h2 v-else>桌台号：{{info.tableName}}</h2>
          <p>就餐人数：{{info.peopleNumber}}</p>
          <p v-if="info.orderCode">单号：{{info.orderCode}}</p>
          <p>时间：{{info.checkoutDate}}</p>
        </div>
        <div class="ticket_info">
          <div class="ticket_info_title">
            <h4>品名</h4>
            <h5>数量</h5>
            <h6>单价</h6>
            <p>金额</p>
          </div>
          <div class="ticket_info_item">
            <div class="ticket_info_list">
              <!--<div class="ticket_info_list_category">
								<h6>*套餐</h6>
								<p>30</p>
							</div>-->
              <div class="ticket_info_list_msg" v-for="(i, index) in info.items">
                <div class="ticket_info_list_name">{{index+1}}.{{i.foodName}}</div>
                <div class="ticket_info_list_msg_info">
                  <h4></h4>
                  <h5>{{i.quantity}}{{i.unit}}</h5>
                  <h6>{{i.price}}</h6>
                  <p>{{i.totalAmount}}</p>
                </div>
                <!--<div class="ticket_info_list_note">备注415245</div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="ticket_footer">
          <div class="ticket_footer_list">
            <h6>数量：</h6>
            <p>{{info.foodCount}}</p>
          </div>
          <div class="ticket_footer_list">
            <h6>金额：</h6>
            <p>{{info.orderTotalAmount}}</p>
          </div>
          <div class="ticket_footer_item">
            <h6>应收金额：</h6>
            <p>{{info.shouldAmount}}</p>
          </div>
          <div class="ticket_footer_item">
            <h6>实收金额：</h6>
            <p>{{info.realAmount}}</p>
          </div>
          <div class="ticket_footer_list" v-for="l in info.payWay">
            <h6>{{l.name}}：</h6>
            <p>{{l.val}}</p>
          </div>
          <!--<div class="ticket_footer_item">
						<h6>找零：</h6>
						<p>0</p>
					</div>-->
          <div class="ticket_footer_list" v-if="info.remarks">
            <h6>备注：{{info.remarks}}</h6>
          </div>
        </div>
        <div class="ticket_bottom">
          <p>谢谢惠顾，欢迎下次光临！</p>
          <p v-if="info.shopAddress">{{info.shopAddress}}</p>
          <p>在线小票模板预览</p>
          <svg id="barcode"></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs';
  import jsbarcode from 'jsbarcode';
  import {
    interfaceFn
  } from '@/assets/util.js';
  export default {
    data() {
      return {
        msg: 'ticket',
        list: [],
        info: {},
        showInfo: false,
        model: 0,
        testInfo: {},
        indexNum: 1,
      }
    },
    watch: {
      info: (val, test) => {
        if (val.orderCode) {
          setTimeout(function() {
            // console.log();
            // _this.getPrintOrderMsgFn(_this.testInfo);
          }, 1000)
        }
      }
    },

    created() {
      var query = this.$route.query || {};
      if (query.waimaiId) {
        this.showList({
          shopId: 0,
          waimaiId: query.waimaiId
        })
      }
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.model = window.localStorage.getItem('model');
        // this.indexNum = 1;
        let loadingInstance = this.$loading({ fullscreen: true });
        this.$http.post(interfaceFn() + '/orderMessage/findOrderMsg',
          qs.stringify({
            "merchantId": window.localStorage.getItem('merchantId'),
            "shopId": window.localStorage.getItem('shopId'),
            "openid": this.$store.state.scanInfo.openid,
            "page": 1,
            "limit": 50,
          }), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((res) => {
          loadingInstance.close();
          if (res.data.returnCode == 'ok') {
            let list = res.data.data;
            this.list = list;
          } else {
            this.msgFn('warning', res.data.message, 1500);
          }
        }).catch(() => {
          loadingInstance.close();
        });

        var query = this.$route.query; //连接参数
        // 模式4支付后跳转显示
        if (query && query.orderCode) {
          let info = {
            waimaiId: query.orderCode
          }
          this.testInfo = info;
          this.showList(info);
        }
      },

      timer(callback, delay) {
        let timerId = setInterval(() => {
          callback(timerId)
        }, delay);
      },

      // 返回
      backFn() {
        var query = this.$route.query;
        let oldCartList = window.localStorage.getItem('oldCartList');
        let newCartList = window.localStorage.getItem('newCartList');
        if (query && query.orderCode || !newCartList && oldCartList == '[]') {
          this.$router.push({
            path: '/room'
          });
        } else {
          this.$router.push({
            path: '/pay'
          });
        }
      },

      // 显示详情
      showList(i) {
        this.getPrintOrderMsgFn(i);
      },

      /* 获取打印的参数 */
      getPrintOrderMsgFn(i) {
        let loadingInstance = this.$loading({ fullscreen: true });
        this.$http.post(interfaceFn() + '/orderMessage/printOrderMsg',
          qs.stringify({
            "waimaiId": i.waimaiId,
            "shopId": window.localStorage.getItem('shopId')
          }), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((res) => {
          loadingInstance.close();
          if (res.data.returnCode == "ok") {
            this.showInfo = true;
            let data = res.data.printInfo;
            let payWay = [];
            for (let i in data.paymentsMap) {
              payWay.push({
                name: i,
                val: data.paymentsMap[i],
              })
            }
            data.payWay = payWay;
            this.info = data;

            if(data.orderCode){
              jsbarcode("#barcode", data.orderCode, {
                format: "CODE128", //选择要使用的条形码类型
                text: data.orderCode,
                displayValue: true, //是否在条形码下方显示文字
                textPosition: "bottom", //设置文本的垂直位置
                fontSize: 22
              });
            }

            // 判断是否有单号
            // this.timer((id) => {
            //   if (!this.info.orderCode) {
            //       this.init();
            //       clearInterval(id);
            //   }
            // }, 5000);

            // 判断是否有单号
            let _this = this;
            if(this.indexNum == 1){
              this.indexNum = 2;
              if(!this.info.orderCode){
                setTimeout(function(){
                  // _this.getPrintOrderMsgFn(_this.testInfo);
                  _this.init();
                },1500)
              }
            }

          } else {
            this.msgFn('warning', res.data.message, 1500);
          }
        }).catch(() => {
          loadingInstance.close();
        });
      },

      // 提示
      msgFn(type, msg, time) {
        this.$Message({
          duration: time,
          message: msg,
          center: true,
          type: type
        });
      },
    }
  }
</script>
<style type="text/css" scoped="scoped">
  @import url("../../static/css/ticket.css");
</style>



// WEBPACK FOOTER //
// src/components/Ticket.vue